import { ACCOUNT_INFO_FRAGMENT } from '../../graphql';

const NAME_FIELDS = `
  id
  name {
    first
    last
  }
`;

/**
 * Builds the IssueMessage selection with a caller-chosen depth for the three
 * Account relationships (`updatedBy`, `guestOf`, `userMentions`). The full
 * read wants names and avatars; an anonymous share-link reply must ask for
 * `{ id }` only — the Anonymous role holds no `account.read`, and a bare id
 * on a relationship short-circuits the permission proxy, whereas any further
 * field would put an `errors` entry on the response and fail the whole
 * mutation client-side.
 */
export const buildIssueMessageFragment = (
  updatedBySelection: string,
  relatedAccountSelection: string
) => `
  id
  type
  text
  reminderData {
    reminderId
    reminderType
    reminderDate
    intervalDays
    startDate
  }
  media {
    id
    name
    type
    extension
    status
  }
  assetRoutine {
    id
    exceptionCount
    data
    createdFrom
    routineVersion {
      id
      type
      config
    }
    createdAt
    createdBy {
      ${NAME_FIELDS}
    }
    updatedAt
    updatedBy {
      ${NAME_FIELDS}
    }
    routine {
      id
    }
  }
  updatedAt
  updatedBy {
    ${updatedBySelection}
  }
  guestOf {
    ${relatedAccountSelection}
  }
  linkedIssue {
    id
  }
  parentMessage {
    id
  }
  userMentions {
    ${relatedAccountSelection}
  }
  reactions{
    id
    createdAt
    createdBy 
    reactionType
  }
  i18n
  actionData
`;

export const ISSUE_MESSAGE_FRAGMENT = buildIssueMessageFragment(
  ACCOUNT_INFO_FRAGMENT,
  NAME_FIELDS
);

/** Response selection for a reply posted as the Anonymous account — see above. */
export const ANONYMOUS_ISSUE_MESSAGE_FRAGMENT = buildIssueMessageFragment(
  'id',
  'id'
);
